

export const Content = [
  {
    category: "about",
    link: `http://linkedin.com/in/darshandeepsingh`,
    name: "Darshan: Technology Enthusiast and Problem Solver.",
    excerpt: `I am a tech enthusiast and developer from Toronto, Canada, passionate about crafting scalable and user-centric web solutions. With a focus on innovation and adaptability, I specialize in building dynamic systems like restaurant POS applications. 'Code is the canvas; innovation is the art.`
    
  },
  {
    category: "about",
    link: `https://www.linkedin.com/in/darshandeepsingh/`,
    name: "An overview of my technical skills and interests",
    excerpt: `HTML, CSS, JavaScript, React, GraphQL, Gatsby, Python, Open Source, Hugo, 
    Documentation, UI Design, UX Research, Inkscape.`
  },
  
  {
    category: "works",
    link: `${window.location.origin}`,
    name: "Portfolio (this website)",
    excerpt: `A personal website simulating the Google Search platform. Developed using React`
  },
  {
    category: "works",
    link: "https:darshan01.netlify.app",
    name: "Personal Website",
    excerpt: `My personal website, designed and developed from scratch. It
    features a lot of hover effects, custom styling and a blog.`
  },
  {
    category: "works",
    link: "https://i.ibb.co/GFbr1d9/POS.png",
    name: "POS (Coming soooon)",
    excerpt: `Introducing our upcoming POS system, designed to streamline restaurant operations with ease. It will offer customizable features to manage orders, track inventory, and simplify payments. With a focus on scalability, it’s built to grow alongside your business needs. Stay tuned for an efficient, user-friendly solution to transform your restaurant management!`
  },

  {
    category: "social",
    link: "https://www.linkedin.com/in/Darshandeepsingh",
    name: "LinkedIn",
    excerpt: `Connect and share experiences`
  },
  {
    category: "social",
    link: "https://github.com/Darshandeep",
    name: "GitHub",
    excerpt: `View upcoming projects.`
  }
];
